import classNames from 'classnames';
import dayjs, { Dayjs } from 'dayjs';
import { CalendarInput } from 'ui';

export interface SelectDateProps {
  label?: string;
  placeholder?: string;
  className?: string;
  handleChangeDates: (dates: [Dayjs | null, Dayjs | null] | null) => void;
  dates: [Dayjs | null, Dayjs | null] | null;
  id?: string;
}

export const SelectDate = ({
  label,
  className,
  handleChangeDates,
  dates,
  placeholder,
  id,
}: SelectDateProps) => {
  return (
    <div
      className={classNames(
        'flex items-center border px-2 rounded-lg gap-2 font-[Inter] text-sm leading-[22px]',
        {
          'min-w-[280px]': !className?.includes('min-w-'),
          'max-w-[380px]': !className?.includes('max-w-'),
          'h-10': !className?.includes('h-'),
        },
        className,
      )}
    >
      {label && (
        <span className="border-r pr-2 min-w-[120px] h-full text-center flex items-center justify-start text-gray-600">
          {label}
        </span>
      )}
      <span className="pl-2 w-full">
        <CalendarInput
          name={'created_at' + id}
          range={true}
          rangeValue={dates?.[0] && dates?.[1] ? [dayjs(dates?.[0]), dayjs(dates?.[1])] : null}
          rangeOnChange={handleChangeDates}
          format="DD-MM-YYYY"
          classNamesPicker="py-0 !border-none"
          placeholder={placeholder}
        />
      </span>
    </div>
  );
};
